/**
 * Downloads a text file with the specified filename and content.
 *
 * @param filename - The name of the file to be downloaded.
 * @param text - The content of the file.
 * @param raw Bypasses encoding if true.
 */
export function download(filename, text, raw = false) {
    const element = document.createElement("a");
    element.setAttribute("href", raw ? text : "data:text/plain;charset=utf-8," + encodeURIComponent(text));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
/**
 * Downloads a binary file with the specified filename and content.
 *
 * @param filename - The name of the file to be downloaded.
 * @param binary - The content of the file.
 */
export function downloadBinary(filename, binary) {
    const blob = new Blob([binary], {
        type: "application/octet-stream",
    });
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
}
//# sourceMappingURL=download.js.map